class Auth {
    public token = '';
    public accountName = '';
    public accountUserName = '';
}

export default Auth;
